import { render, staticRenderFns } from "./editHBFY.vue?vue&type=template&id=34a7248b&"
import script from "./editHBFY.vue?vue&type=script&lang=js&"
export * from "./editHBFY.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports